// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 774 ? "framework" : chunkId) + "-" + {"181":"86d37d0e49838a40fb9c","666":"073b3387c6b04a61d141","774":"a93f18055a0d208fb4f6"}[chunkId] + ".js";
};